import Clarity from '@microsoft/clarity';
import {
    ENVIRONMENTS,
    getEnvironment,
    isDevEnv,
    userConsentGiven,
} from '../utils/environment';

const productionProjectId = 'oxhigmdp5m';
const stagingProjectId = 'oxiotzcdqo';

let initialized = false;

function getProjectId() {
    const environment = getEnvironment();
    switch (environment) {
        case ENVIRONMENTS.DEVELOPMENT:
            return '';
        case ENVIRONMENTS.STAGING:
            return stagingProjectId;
        case ENVIRONMENTS.PRODUCTION:
            return productionProjectId;
    }
}

export function initClarity() {
    if (isDevEnv() || !userConsentGiven() || initialized) {
        return;
    }

    const projectId = getProjectId();
    if (!projectId) {
        return;
    }

    Clarity.init(projectId);
    Clarity.setTag('environment', getEnvironment());
    initialized = true;
}

function safeClarityCall(fn: () => void) {
    if (isDevEnv() || !userConsentGiven()) {
        return;
    }

    initClarity();

    try {
        fn();
    } catch {
        // Clarity may be blocked by an ad blocker or still loading.
    }
}

export function trackClarityEvent(eventName: string) {
    safeClarityCall(() => Clarity.event(eventName));
}

export function identifyClarityUser(
    customerId: string,
    customPageId: string,
    friendlyName: string,
) {
    safeClarityCall(() =>
        Clarity.identify(customerId, undefined, customPageId, friendlyName),
    );
}
